/* PLACE-CONTEXT-PRESETS-01
 * Static viewport preset provider.
 * No DOM, events, fetch, storage or map rendering.
 * Presets do not establish Place identity or relationships.
 */
(function () {
  'use strict';

  const VERSION = '2026-10-11-place-context-presets-01';
  const existing = window.LittleGCityMissionMapScene;

  if (existing && existing.version === VERSION) return;

  const presets = Object.freeze({
    'hong-kong-overview': Object.freeze({
      id: 'hong-kong-overview',
      labelZh: '香港概覽',
      labelEn: 'Hong Kong overview',
      purpose: 'initial-viewport',
      provenance: 'existing-map-default',
      center: Object.freeze([22.3193, 114.1694]),
      zoom: 12
    })
  });

  window.LittleGCityMissionMapScene = Object.freeze({
    version: VERSION,
    role: 'static-viewport-preset-provider',
    getPreset: function (id) {
      return Object.prototype.hasOwnProperty.call(presets, id)
        ? presets[id]
        : null;
    }
  });
})();
